import isotypeUrl from "@/assets/svg/isotipo04.svg";
import { cn } from "@/shared/lib/utils";

const MASK = `url("${isotypeUrl}") center / contain no-repeat`;

export interface ColocaIsotypeProps {
  className?: string;
}

/**
 * Coloca's mark alone, painted in the current text colour (a mask over `bg-current`), so it follows the theme
 * and sits on any surface: `text-primary-foreground` on a primary tile, `text-primary` on a card.
 * Decorative.
 */
export function ColocaIsotype({ className }: ColocaIsotypeProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-block size-5 shrink-0 bg-current", className)}
      style={{ mask: MASK, WebkitMask: MASK }}
    />
  );
}
